import TitleMetadata from '@models/TitleMetadata'
import i18n from '@utils/i18n'

const OTHER = 'other'
const SMALL_ENSEMBLE = 'smallEnsemble'
const CHORAL = 'choral'
const EXERCISE = 'exercise'

const SHOW_INSTRUMENTS_FOR = {
  solo: true,
  duet: true,
  smallEnsemble: true,
  other: true,
}

// If all instruments are "other", don’t show instruments. If only one of the
// instruments is "other", put it at the end of the list.
function handleOtherInstruments(instruments: string[]): string[] {
  if (instruments) {
    const index = instruments.indexOf(OTHER)
    if (index !== -1) {
      instruments.splice(index, 1)
      if (instruments.length === 0) {
        return instruments
      }
      instruments.push(OTHER)
      return instruments
    }
  }

  return instruments
}

function getInstrumentDisplayName(instrumentName: string): string {
  if (instrumentName == OTHER) return i18n.t('content.other')
  return i18n.t(`genericInstrument.${instrumentName}`)
}

function getInstruments(metadata: TitleMetadata): string {
  const { instruments, format } = metadata
  const instrumentsArray = handleOtherInstruments(instruments)
  const colon = format == OTHER || !instruments || instruments.length === 0 ? '' : ': '

  if (instrumentsArray && format && SHOW_INSTRUMENTS_FOR[format]) {
    if (format == SMALL_ENSEMBLE && instrumentsArray.length > 1) {
      return `: ${i18n.t('content.various')}`
    }

    const instrumentStrings = instrumentsArray.map((i) => getInstrumentDisplayName(i))
    return `${colon}${instrumentStrings.join(', ')}`
  }

  return ''
}

function getFormat(metadata: TitleMetadata): string {
  const { format, simplified_voicings, exercise_format } = metadata
  if (!format || format === OTHER) return ''
  if (format === CHORAL && simplified_voicings.length > 0)
    return simplified_voicings.map((voicing) => i18n.t(`format.${voicing}`)).join(', ')
  if (format === EXERCISE) return exercise_format.map((fmt) => i18n.t(`format.${fmt}`)).join(', ')
  return i18n.t(`format.${format}`)
}

/**
 * Creates a string that can be used by the product to show the format + instruments
 */
export function buildFormatString(metadata: TitleMetadata) {
  return `${getFormat(metadata)}${getInstruments(metadata)}`
}
